// Local storage utility for managing user's reports
// Each stored report is a JSON object: { reportId, reportSecret }

import { getJSON, setJSON } from './localStorageUtils';

export const getUserReports = () => {
  const stored = getJSON('userReports', []);
  return Array.isArray(stored) ? stored : [];
};

export const addUserReport = (reportId, reportSecret) => {
  const userReports = getUserReports();
  if (!userReports.some(r => r.reportId === reportId)) {
    userReports.push({ reportId, reportSecret });
    setJSON('userReports', userReports);
  }
};

export const removeUserReport = (reportId) => {
  const userReports = getUserReports();
  const updatedReports = userReports.filter(r => r.reportId !== reportId);
  setJSON('userReports', updatedReports);
};

export const isUserReport = (reportId) => {
  return getUserReports().some(r => r.reportId === reportId);
};

export const getUserReportSecret = (reportId) => {
  const report = getUserReports().find(r => r.reportId === reportId);
  return report ? report.reportSecret : null;
};
